import Operator from "../models/Operator";
export const OperatorMixin = {
  data() {
    return {
      operator: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Operator({
        name: null,
        is_individual: true,
        country_id: undefined,
      })
    }
  }
}
